export const MAX_UPLOAD_COUNT = 25;
export const MAX_UPLOAD_SIZE = 20000000;

export const MAX_UPLOAD_SIZE_DISPLAY = `${MAX_UPLOAD_SIZE / 1000000} MB`;

export const ATTACHMENT_UPLOAD_GUIDELINES = `You can select up to ${MAX_UPLOAD_COUNT} image, video, Word, Excel, text, HTML, \
        or non-password protected PDF files. All files must total less than ${MAX_UPLOAD_SIZE_DISPLAY}.`;

export const FILE_TYPES = {
  IMAGE: 'image', // use with .includes since an image can be image/jpg, image/png, etc.
  VIDEO: 'video', // use with .includes since a video can be .mp4, .mov, etc.
};

export const ATTACHMENT_STATUS = {
  IMPERSONATION_DETECTED: 'impersonation-detected',
  STATUS_COMPLETE: 'complete',
};

export const ACCEPTED_FILE_TYPES =
  'image/*, video/*, .pdf, .HTML, .text, .txt, .rtf, .doc, .docx, .xls, .xlsx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const ACCEPTED_FILE_TYPES_DETAILED =
  'image/jpeg, image/gif, image/avif, image/png, image/svg+xml, image/apng, image/heif, image/heif-sequence, image/heic, image/heic-sequence, video/*, .pdf, .HTML, .text, .txt, .rtf, .doc, .docx, .xls, .xlsx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const FILE_UPLOAD_ERROR_MESSAGE =
  'An error has occurred preventing file uploads. Please try refreshing the page.';
export const ERROR_MESSAGE_SUBSTRING = 'Try sending additional files in a subsequent message.';
export const MAX_UPLOAD_COUNT_ERROR_MESSAGE = `You have reached the max upload count of ${MAX_UPLOAD_COUNT} files for this message. ${ERROR_MESSAGE_SUBSTRING}`;
